import React from "react";
import { connect } from "react-redux";
import ResponsiveDrawer from "../components/ResponsiveDrawer";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import EmailIcon from "@mui/icons-material/Email";
import Divider from "@mui/material/Divider";
import Avatar from "@mui/material/Avatar";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Icon from "@mdi/react";
import {
  mdiFileCheck,
  mdiFileLock,
  mdiCreditCard,
  mdiInstagram,
  mdiFacebook,
  mdiWeb,
  mdiApple,
  mdiGooglePlay,
  mdiFrequentlyAskedQuestions,
  mdiCalendarCheck,
} from "@mdi/js";
import { Redirect } from "react-router-dom";

import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => {
  return {
    root: {
      minHeight: "100vh",
      backgroundColor: "#F7F8FA",
    },
    toolbar: {
      height: "64px",
    },
  };
});

function Contact(props) {
  let tokenStorage = null;

  const classes = useStyles();

  // Redirect user if not logged in
  const isLoggedIn = localStorage.getItem("token");
  // console.log(">>local storage", isLoggedIn);
  if (isLoggedIn) {
    tokenStorage = isLoggedIn.slice(1, isLoggedIn.length - 1);
  }
  if (!props.token && !isLoggedIn) {
    return <Redirect to="/" />;
  }
  if (!props.token && isLoggedIn) {
    // passing the token in the redux store
    props.onSetToken(tokenStorage);
  }

  return (
    <Box sx={{ display: "flex" }}>
      <ResponsiveDrawer />
      <Box className={classes.root} sx={{ flexGrow: 1, p: 3 }}>
        <div className={classes.toolbar}></div>

        <Grid container>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              // alignItems: "center",
              flexDirection: "column",
            }}
          >
            {/*  */}
            <Box
              mb={3}
              sx={{
                display: "flex",
                flexDirection: "column",
                // alignItems: "center",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Informations et contact
              </Typography>
            </Box>

            <Box mb={3} p={3} className="boxContact">
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Contacter Carlo
              </Typography>
              <Typography variant="h7">
                Contactez le service client Carlo pour reporter un problème ou
                demander de l'aide
              </Typography>
              <Box
                mt={2}
                mb={2}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                {/*  */}
                <Box className="boxDetails">
                  <Link href="tel:+377640617543">
                    <Avatar sx={{ bgcolor: "#e9e8e8", width: 35, height: 35 }}>
                      <PhoneInTalkIcon sx={{ color: "#006EFF" }} />
                    </Avatar>
                  </Link>
                  <Link
                    href="tel:+377640617543"
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    <Typography ml={1}>+377 6 40 61 75 43</Typography>
                  </Link>
                </Box>
                <Box className="boxDetails">
                  <Link href="mailto:hello@carloapp.com">
                    <Avatar sx={{ bgcolor: "#e9e8e8", width: 35, height: 35 }}>
                      <EmailIcon sx={{ color: "#006EFF" }} />
                    </Avatar>
                  </Link>
                  <Link
                    href="mailto:hello@carloapp.com"
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    <Typography ml={1}>hello@carloapp.com</Typography>
                  </Link>
                </Box>
              </Box>
              <Divider variant="middle" />
              <Box mt={2} sx={{ display: "flex", flexDirection: "row" }}></Box>

              <Box mb={2} className="boxDetails">
                <Link
                  href="https://carloapp.com/merchant-faqs-fr/"
                  target="_blank"
                >
                  <Avatar
                    sx={{
                      bgcolor: "#e9e8e8",
                      width: 35,
                      height: 35,
                      color: "#006EFF",
                    }}
                  >
                    <Icon path={mdiFrequentlyAskedQuestions} size={1} />
                  </Avatar>
                </Link>
                <Link
                  href="https://carloapp.com/merchant-faqs-fr/"
                  target="_blank"
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <Typography ml={1}>Foire aux questions</Typography>
                </Link>
              </Box>

              <Box mb={2} className="boxDetails">
                <Link href="https://carloapp.com/cgv-commerce/" target="_blank">
                  <Avatar
                    sx={{
                      bgcolor: "#e9e8e8",
                      width: 35,
                      height: 35,
                      color: "#006EFF",
                    }}
                  >
                    <Icon path={mdiFileCheck} size={1} />
                  </Avatar>
                </Link>
                <Link
                  href="https://carloapp.com/cgv-commerce/"
                  target="_blank"
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <Typography ml={1}>Conditions générales</Typography>
                </Link>
              </Box>

              <Box mb={2} className="boxDetails">
                <Link
                  href="https://carloapp.com/confidentialite-commerce/"
                  target="_blank"
                >
                  <Avatar
                    sx={{
                      bgcolor: "#e9e8e8",
                      width: 35,
                      height: 35,
                      color: "#006EFF",
                    }}
                  >
                    <Icon path={mdiFileLock} size={1} />
                  </Avatar>
                </Link>
                <Link
                  href="https://carloapp.com/confidentialite-commerce/"
                  target="_blank"
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <Typography ml={1}>Politque de confidentialité</Typography>
                </Link>
              </Box>

              <Box className="boxDetails">
                <Link
                  href="https://www.lemonway.com/conditions-generales-dutilisation/"
                  target="_blank"
                >
                  <Avatar
                    sx={{
                      bgcolor: "#e9e8e8",
                      width: 35,
                      height: 35,
                      color: "#006EFF",
                    }}
                  >
                    <Icon path={mdiCreditCard} size={1} />
                  </Avatar>
                </Link>
                <Link
                  href="https://www.lemonway.com/conditions-generales-dutilisation/"
                  target="_blank"
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  <Typography ml={1}>
                    Conditions d'utilisation de Lemonway
                  </Typography>
                </Link>
              </Box>
              {/*  */}
            </Box>

            <Box mb={3} p={3} className="boxContact">
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Suivre Carlo sur les réseaux sociaux
              </Typography>
              {/*  */}
              <Box
                mt={2}
                mb={2}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                {/*  */}
                <Box mb={2} className="boxDetails">
                  <Link
                    href="https://www.instagram.com/carlo.app.aixenprovence/"
                    target="_blank"
                  >
                    <Avatar
                      sx={{
                        bgcolor: "#e9e8e8",
                        width: 35,
                        height: 35,
                        color: "#006EFF",
                      }}
                    >
                      <Icon path={mdiInstagram} size={1} />
                    </Avatar>
                  </Link>
                  <Link
                    href="https://www.instagram.com/carlo.app.aixenprovence/"
                    target="_blank"
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    <Typography ml={1}>
                      instagram.com/carlo.app.aixenprovence
                    </Typography>
                  </Link>
                </Box>

                <Box mb={2} className="boxDetails">
                  <Link
                    href="https://www.facebook.com/carlo.app.aixenprovence/"
                    target="_blank"
                  >
                    <Avatar
                      sx={{
                        bgcolor: "#e9e8e8",
                        width: 35,
                        height: 35,
                        color: "#006EFF",
                      }}
                    >
                      <Icon path={mdiFacebook} size={1} />
                    </Avatar>
                  </Link>
                  <Link
                    href="https://www.facebook.com/carlo.app.aixenprovence/"
                    target="_blank"
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    <Typography ml={1}>
                      facebook.com/carloapp.aixenprovence
                    </Typography>
                  </Link>
                </Box>

                <Box mb={2} className="boxDetails">
                  <Link href="https://carloapp.com" target="_blank">
                    <Avatar
                      sx={{
                        bgcolor: "#e9e8e8",
                        width: 35,
                        height: 35,
                        color: "#006EFF",
                      }}
                    >
                      <Icon path={mdiWeb} size={1} />
                    </Avatar>
                  </Link>
                  <Link
                    href="https://carloapp.com"
                    target="_blank"
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    <Typography ml={1}>Visitez notre site Web</Typography>
                  </Link>
                </Box>

                <Box mb={2} className="boxDetails">
                  <Link
                    href="https://apps.apple.com/fr/app/carlo-app-business/id1386996897"
                    target="_blank"
                  >
                    <Avatar
                      sx={{
                        bgcolor: "#e9e8e8",
                        width: 35,
                        height: 35,
                        color: "#006EFF",
                      }}
                    >
                      <Icon path={mdiApple} size={1} />
                    </Avatar>
                  </Link>
                  <Link
                    href="https://apps.apple.com/fr/app/carlo-app-business/id1386996897"
                    target="_blank"
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    <Typography ml={1}>Notez-nous sur l'App Store</Typography>
                  </Link>
                </Box>

                <Box className="boxDetails">
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.carlotechnologies.carlobusiness&hl=fr&gl=US"
                    target="_blank"
                  >
                    <Avatar
                      sx={{
                        bgcolor: "#e9e8e8",
                        width: 35,
                        height: 35,
                        color: "#006EFF",
                      }}
                    >
                      <Icon path={mdiGooglePlay} size={1} />
                    </Avatar>
                  </Link>
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.carlotechnologies.carlobusiness&hl=fr&gl=US"
                    target="_blank"
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    <Typography ml={1}>Notez-nous sur Google Play </Typography>
                  </Link>
                </Box>
                {/*  */}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Box>
    </Box>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    onSetToken: function (token) {
      dispatch({ type: "setToken", token: token });
    },
  };
}

function mapStateToProps(state) {
  return { token: state.token };
}

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
